import { BrandMark } from "@diffex/ui";

export function LoadingScreen() {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <BrandMark className="product-brand" />
      <span className="loading-line" aria-hidden="true" />
      <span className="sr-only">Loading your workspace</span>
    </div>
  );
}
